import Vue from 'vue';

Vue.component('dropdown', require('@mobile/components/Dropdown').default);
Vue.component('dropdown-menu', require('@mobile/components/DropdownMenu').default);
Vue.component('dropdown-trigger', require('@mobile/components/DropdownTrigger').default);
Vue.component('modal', require('@mobile/components/Modal').default);
Vue.component('bottom-navigation', require('@mobile/components/BottomNavigation').default);
Vue.component('checkbox', require('@/components/Index/Checkbox').default);
Vue.component('star-icon', require('@mobile/components/Icons/Star.vue').default);

Vue.directive('pull-to-refresh', require('@mobile/directives/pullToRefresh').default);
